import { useQuery } from '@hooks/reactQuery';

import { getDasNames, getSeveritiesFlexidas } from '@api/common';

import { optionsFormatted, optionsFormattedByName } from '@utils/formatter';

import { IAlarmByVendorFilter, IAlarmFilter } from '@interfaces/alarms/alarm';
import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import {
	ALARM_DAS_NAMES,
	ALARM_SEVERITIES_FLEXIDAS,
} from '@constants/queryKeys';
import { statusAlarmHistoryFlexiDasOptions } from '@components/routes/AdminPanel/Alarms/AlarmByVendor/constants';

import { IAlarmFiltersProps } from './useActiveAlarmFilters';

export const useQueryFlexidasActiveAlarmFilters = ({
	vendor,
	isActiveTab,
}: IAlarmFiltersProps): IAlarmByVendorFilter => {
	const isEnabled = vendor === EVendorsValues.flexidas;

	const {
		data: severities,
		isInitialLoading: isLoadingSeverities,
	} = useQuery<Array<TNameTitle>, TSelectOption<string>[]>({
		queryKey: [ALARM_SEVERITIES_FLEXIDAS],
		queryFn: getSeveritiesFlexidas,
		select: (severities) => optionsFormatted<TNameTitle>(severities),
		enabled: [isEnabled],
		...refetchOptions,
	});

	const {
		data: dasNames,
		isInitialLoading: isLoadingDasNames,
	} = useQuery<Array<TNameTitle>, TSelectOptionType<string>[]>({
		queryKey: [ALARM_DAS_NAMES],
		queryFn: getDasNames,
		select: (names) => optionsFormattedByName(names),
		enabled: [isEnabled],
		...refetchOptions,
	});

	const activeFilters: IAlarmFilter[] = isEnabled ? [
		{
			name: 'alarmSeverity',
			placeholder: 'Severity',
			data: severities || [],
		},
		{
			name: 'alarmDasIndex',
			placeholder: 'DAS name',
			data: dasNames || [],
		},
	] : [];

	const filters = !isActiveTab
		? [
			...activeFilters,
			{
				name: 'isActive',
				placeholder: 'Active',
				data: statusAlarmHistoryFlexiDasOptions,
			},
		] : activeFilters;

	return {
		filters,
		isLoading: isLoadingDasNames || isLoadingSeverities,
	};
};
